import { render, staticRenderFns } from "./add-images-work.vue?vue&type=template&id=32cbf092&scoped=true"
import script from "./add-images-work.vue?vue&type=script&lang=js"
export * from "./add-images-work.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32cbf092",
  null
  
)

export default component.exports